import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Offers from "@/pages/Offers";

export const Route = createFileRoute("/offers")({
  head: () => seoHead("/offers"),
  component: Offers,
});
